import { Clickable } from '@routable/gross-ds';
import React from 'react';
import { CustomerServiceHelper } from 'modules/customerSupport';
export const VendorsCannotReceiveInvoicesText = () => {
    return (React.createElement("span", null,
        "Vendors cannot receive invoices through Routable. You can create a new customer record, or",
        ' ',
        React.createElement(Clickable, { onClick: () => CustomerServiceHelper.show(), variant: "inherit" }, "contact support"),
        ' ',
        "if you need the customer and vendor records linked."));
};
